(function () {
	angular
		.module('trackeye')
		.factory('GenericXhrLogger', _GenericXhrLoggerFactory);

	_GenericXhrLoggerFactory.$inject = [];

	function _GenericXhrLoggerFactory() {

		/**
		 * @constructor
		 * @param {ResponseXHR} xhr
		 */
		function GenericXhr(xhr) {
			this.debug = false;
			this.xhr = xhr;
			this.level = 'info';
			this.silent = false;
		}

		GenericXhr.prototype.isSilent = function () {
			return this.silent;
		};

		GenericXhr.prototype.getLevel = function () {
			return this.level;
		};

		GenericXhr.prototype.getMessageId = function () {
			return this.xhr.is50x() ? "GENERIC_XHR_SERVER_ERROR" : "GENERIC_XHR_CLIENT_ERROR";
		};

		GenericXhr.prototype.getMessage = function () {
			var data = this.xhr.getResponseData(),
				msg = this.xhr.getStatus()+" ";

			if (this.xhr.is50x() || this.xhr.BadRequest()) {
				msg += data.title;
				if (data.message) {
					msg += " -> "+data.message;
				}
			}

			return msg;
		};

		GenericXhr.prototype.getData = function () {
			if (this.xhr.BadRequest) {
				return this.xhr.getRequestData();
			}

			if (!this.xhr.is50x() || this.xhr.GatewayTimeout()) {
				return this.xhr.getResponseData();
			} else if (this.xhr.InternalServerError()) {
				return {};
			}
		};

		GenericXhr.prototype.getXhr = function () {
			return this.xhr;
		};

		GenericXhr.prototype.getNoticeType = function () {
			return this.xhr.is50x() ? "danger" : "warning";
		};

		GenericXhr.prototype.getNoticeMessage = function () {
			var msg = undefined;

			if (this.xhr.is50x() || this.xhr.BadRequest() || this.xhr.NotAcceptable()) {
				this.silent = false;
				this.level = 'err';

				if (this.xhr.is50x())
					return "STR_ERROR_NOTICE_GENERIC_XHR_HTTP_50x";

				if (this.xhr.BadRequest())
					return "STR_ERROR_NOTICE_GENERIC_XHR_HTTP_400";

				if (this.xhr.NotAcceptable())
					return "STR_ERROR_NOTICE_GENERIC_XHR_HTTP_406";
			}

			return undefined;
		};

		GenericXhr.prototype.getTranslateValues = function () {
			return {};
		};

		return GenericXhr;
	}
})();